import { IState } from '../types';
import { ELanguageStatus, EUserGroupType } from '../general/types';
import {
  TAudio,
  TLanguage,
  TUserGroup,
  TUserLanguage,
  TUserRole,
} from './types';
import { EMPTY_ARRAY } from '../../../common/types';

export const getGroups = (state: IState) => {
  return state.models.groups || EMPTY_ARRAY;
}

export const getUserGroups = (state: IState) => {
  return (state.models.groups || EMPTY_ARRAY).filter(g => g.type !== EUserGroupType.CONFERENCE)
}

export const getConferenceUserGroups = (state: IState) => {
  return (state.models.groups || EMPTY_ARRAY).filter(g => g.type === EUserGroupType.CONFERENCE)
}

export const getUserLanguages = (state: IState) => state.models.languages;

export const getTargetLanguage = (state: IState) => {
  return getUserLanguageByStatus(state, ELanguageStatus.TO_LEARN);
};
export const getNativeLanguage = (state: IState) => {
  return getUserLanguageByStatus(state, ELanguageStatus.KNOW);
};

// the viewer's native language code, unless the lesson is in it — then there's nothing to translate
export const getNativeLangCodeToTranslate = (state: IState, audioId: number): string | undefined => {
  const code = getNativeLanguage(state)?.code;
  return code && code !== getAudioById(state, audioId)?.language?.code ? code : undefined;
};

export const getUserLanguageByStatus = (state: IState, status: ELanguageStatus) => {
  const languages = getUserLanguages(state);
  return languages.find((lang) => lang.status === status) || null;
};

export const getActiveGroupId = (state: IState) => {
  return state.models.activeGroupId;
};

/*export const getUserGroupById = (
  state: IState,
  groupId: number
) => {
  if (!groupId) return null;
  const groups = getUserGroups(state);
  if (!groups || !groups.length) return null;
  return groups.find(group => group.id === groupId);
};*/

export const getUserGroupById = (
  state: IState,
  groupId: number
) => {
  if (!groupId) return null;
  return state.models.groups.find(g => g.id === groupId)
};

export const getActiveUserGroup = (state: IState) => {
  const activeGroupId = getActiveGroupId(state);
  if (!activeGroupId) return null;
  return getUserGroupById(state, activeGroupId);
};

export const getActiveGroupTargetLanguage = (state: IState) => {
  const activeGroup = getActiveUserGroup(state);
  if (!activeGroup) return null;
  return activeGroup.languages.find(lang => lang.status === ELanguageStatus.TO_LEARN) || null;
};

export const getActiveGroupNativeLanguage = (state: IState) => {
  const activeGroup = getActiveUserGroup(state);
  if (!activeGroup) return null;
  return activeGroup.languages.find(lang => lang.status === ELanguageStatus.KNOW) || null;
};

export const getGroupTargetLanguage = (state: IState, group: TUserGroup): TUserLanguage | null => {
  return group.languages.find(lang => lang.status === ELanguageStatus.TO_LEARN) || null;
};

export const getAudioById = (state: IState, id: number): TAudio | undefined => {
  let result: TAudio | undefined;
  getGroups(state).forEach(g => {
    if (result) return;
    result = g.audios?.find(a => a.id === id);
  })
  return result;
}

export const isValidUserGroupAudio = (state: IState, groupId: number, audioId: number): boolean => {
  const group = getUserGroupById(state, groupId);
  if (!group) return false;
  return (!!group.audios?.find(a => a.id === audioId));
}

export const getLanguages = (state: IState, withContentOnly?: boolean): TLanguage[] => {
  const langs = state.models.langs
  return !withContentOnly ? langs : langs.filter(l => !!l.contentLibVideosExist)
}

export const findLanguageByCode = (state: IState, code: string): TLanguage | undefined => {
  return getLanguages(state).find(l => l.code === code);
}

export const findLanguageById = (state: IState, id: number): TLanguage | undefined => {
  return getLanguages(state).find(l => l.id === id);
}

export const getUserRoles = (state: IState): TUserRole[] => {
  return state.models.userRoles;
}

export const isUserGroupsLoaded = (state: IState) => state.models.groupsLoaded;
